import { useOrder } from "@/context";

export function usePagamento() {
  const { order } = useOrder();
  
  return { order };
}
